// Committed zone/DST boundary fixtures (ADR-096 Rule 10). Host ICU zone data
// is outside repo control — a platform update to the IANA tzdata bundled with
// the runtime can silently move a member's day. This table cannot PREVENT
// that; it converts it into a CI failure attributable to the host rather than
// a quiet drift, by pinning exact expected instants for the boundary shapes
// this repo depends on getting right.

import type { WallTime } from './wall-time';

export interface ZoneDriftFixture {
  description: string;
  zone: string;
  wallTime: WallTime;
  /** Expected UTC instant, as an ISO-8601 string with millisecond precision. */
  expectedUtcIso: string;
}

export const ZONE_DRIFT_FIXTURES: readonly ZoneDriftFixture[] = [
  {
    description: 'spring-forward gap: a nonexistent local time resolves forward to the transition',
    zone: 'America/New_York',
    wallTime: { year: 2026, month: 3, day: 8, hour: 2, minute: 30 },
    expectedUtcIso: '2026-03-08T07:00:00.000Z',
  },
  {
    description: 'fall-back ambiguity: an ambiguous local time resolves to the earlier occurrence',
    zone: 'America/New_York',
    wallTime: { year: 2026, month: 11, day: 1, hour: 1, minute: 30 },
    expectedUtcIso: '2026-11-01T05:30:00.000Z',
  },
  {
    description: "America/Havana's DST transition falls at local midnight itself",
    zone: 'America/Havana',
    wallTime: { year: 2026, month: 11, day: 1, hour: 0, minute: 0 },
    expectedUtcIso: '2026-11-01T04:00:00.000Z',
  },
  {
    description: 'a half-hour-offset zone with no DST',
    zone: 'Asia/Kolkata',
    wallTime: { year: 2026, month: 8, day: 6, hour: 7, minute: 30 },
    expectedUtcIso: '2026-08-06T02:00:00.000Z',
  },
  {
    description:
      'a zone that has changed its rules: Europe/Moscow has observed a fixed UTC+3 offset with no DST since 2014',
    zone: 'Europe/Moscow',
    wallTime: { year: 2026, month: 7, day: 1, hour: 12, minute: 0 },
    expectedUtcIso: '2026-07-01T09:00:00.000Z',
  },
] as const;
